import { computed } from 'mobx';
import { PartialDeep } from 'type-fest';

import { translate } from 'services/i18nService';
import { AbstractTheme, CampaignFlagsMap, ControlledFeaturesMap, Theme } from 'themes/themes.types';
import { getThemePart } from 'themes/utils';

import styles from './DayOfferTheme.css';


const FREE_TOKENS_AMOUNT = 50;
const SLOGAN_TRANSLATE_KEY = 'campaigns.easter2020.mobilePop.body';
const TOKEN_OFFER_TRANSLATE_KEY = 'campaigns.24hr.tokenOverlay.title';

export default class DayOfferTheme extends AbstractTheme {
  static CFS: ControlledFeaturesMap = {};
  static CAMPAIGN_FLAGS: CampaignFlagsMap = {
    HEADER_CTA: '24_HOURS_OFFER_HEADER_CTA',
    BUY_TOKENS_MODAL: '24_HOURS_OFFER_BUY_TOKENS_MODAL',
  };

  @computed get theme(): PartialDeep<Theme> {
    return {
      headerCTA: getThemePart<'headerCTA'>(DayOfferTheme.CAMPAIGN_FLAGS.HEADER_CTA, (campaign) => {
        return {
          cookieNamePrefix: campaign.activeCampaignName,
          wrapperClass: styles.headerCTAWrapper,
          title: translate(SLOGAN_TRANSLATE_KEY,
            { 0: campaign.campaignDetails.bonusTokenPercent }
          ),
        };
      }),

      buyTokensModal: getThemePart<'buyTokensModal'>(DayOfferTheme.CAMPAIGN_FLAGS.BUY_TOKENS_MODAL, (campaign) => {
        return {
          cookieNamePrefix: campaign.activeCampaignName,
          headerClass: styles.buyTokensModalHeader,
          title: translate(SLOGAN_TRANSLATE_KEY),
          text: translate(TOKEN_OFFER_TRANSLATE_KEY,
            {
              0: campaign.campaignDetails.bonusTokenPercent,
              1: FREE_TOKENS_AMOUNT,
            }
          ),
        };
      }),

    };
  }
}
